import FlagBaseIcon, { FlagEmojiIconProps } from "./FlagBaseIcon";

const SwedenFlagEmojiIcon = (props: FlagEmojiIconProps) => {
  return <FlagBaseIcon {...props}>🇸🇪</FlagBaseIcon>;
};

export default SwedenFlagEmojiIcon;
